import React from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  DoughnutController,
  type ChartOptions,
  type ChartData
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend, DoughnutController);

interface DoughnutChartProps {
  data?: number[];
  labels?: string[];
  colors?: string[];
  height?: number;
  cutout?: string;
  rotation?: number;
  circumference?: number;
}

const DoughnutChart: React.FC<DoughnutChartProps> = ({
  data = [12, 19, 3],
  labels = ['Red', 'Blue', 'Yellow'],
  colors = ['#ff6384', '#36a2eb', '#ffce56'],
  height = 100,
  cutout = '70%',
  rotation,
  circumference
}) => {
  const chartData: ChartData<'doughnut'> = {
    labels,
    datasets: [
      {
        data,
        backgroundColor: colors,
        borderWidth: 0,
        hoverOffset: 4
      },
    ],
  };

  const options: ChartOptions<'doughnut'> = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: cutout,
    rotation: rotation,
    circumference: circumference,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return <div style={{ height: height, width: '100%', position: 'relative' }}><Doughnut options={options} data={chartData} /></div>;
};

export default DoughnutChart;
